import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-visitor-selfie',
  templateUrl: './visitor-selfie.component.html',
  styleUrls: ['./visitor-selfie.component.scss']
})
export class VisitorSelfieComponent implements OnInit {

 

  public webcamImage: any = null;
  Contact_No
  constructor(public appservice:AppService,private toastr: ToastrService, public router: Router, private http: HttpClient) { 
    
    this.Contact_No = this.appservice.getItem("Phone_Number");
  }


  take_photo()
  {
    this.appservice.Cam_Type = "Photo";    
    return this.router.navigate(['/visitor-camera']);
  }

  checkImageExists(imageUrl: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      fetch(imageUrl)
        .then(response => {
          if (response.ok) {
            resolve(true); // Image exists
          } else {
            reject(`Image not found or error occurred: ${response.status}`);
          }
        })
        .catch(error => {
          reject(error.message);
        });
    });
  }
  

    public Valid: boolean = true;
    public add: any = {};
    public btndisable: boolean = false;

    addData() {
      this.Valid = true;

      // Check if `Selfie_Image` is available or if the image exists at the specified URL
      if (!this.appservice.Selfie_Image) {
        const imageUrl = `${this.appservice.Server_URL}/image/V${this.appservice.Company_}/V${this.Contact_No}.png`;

        this.checkImageExists(imageUrl)
          .then((imageExists) => {
            if (!imageExists) {
              // If neither Selfie_Image nor the image at URL exists, show error and stop execution
              this.Valid = false;
              this.toastr.error('Take a selfie to proceed.', "Error", { timeOut: 3000 });
              return;
            }
            // Proceed with data addition if image exists at URL
            this.processAddData();
          })
          .catch((error) => {
            console.error(error);
            this.Valid = false;
            this.toastr.error('Take a selfie to proceed.', "Error", { timeOut: 3000 });
          });
      } else {
        // Proceed with data addition if Selfie_Image is present
        this.processAddData();
      }
    }

    // Separate method for the main logic to process and submit data
    private processAddData() {
      if (this.Valid) {
        this.add.Company = this.appservice.Company_;
        this.add.Company_ID = this.appservice.Company_;
        this.add.Created_by = this.appservice.CREATED_BY;
        this.add.Contact_No = this.Contact_No;
        this.add.image = this.appservice.Selfie_Image || null;
        this.btndisable = true;

        this.http
          .post(this.appservice.Server_URL + 'api/Visitor/Upload_Document', this.add, { headers: this.appservice.headers })
          .subscribe(
            (val: string) => {
              this.btndisable = false;
              if (val == "True") {
                this.router.navigate(['/visitor-proofid']);
              } else {
                this.toastr.error(val, "Error", { timeOut: 3000 });
              }
            },
            (response) => {
              this.toastr.error('Error', response, { timeOut: 3000 });
            }
          );
      }
    }


  ngOnInit(): void {
  }
  
}
